var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.$store.getters['resource/currentResource'].key,staticClass:"white-container"},[_c('EmailView',{attrs:{"fields":_vm.fields,"editing":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }